// extracted by mini-css-extract-plugin
export default {"root":"Ve2HkzQ"};